export const apiStatusToLabel: Record<string, string> = {
  'unassigned': '後備',
  'assigned': '已分配/未出',
  'distributed': '未收',
  'collected': '實收',
  'collected_bank': '入銀行',
  'collected_empty': '吉袋',
  'collected_other': '已收（其他）',
  'lost': '遺失',
  'late': '遲交',
};

export function translateErrorMessage(errorMsg: string): string {
  if (!errorMsg) return errorMsg;
  
  let translatedMsg = errorMsg;
  Object.entries(apiStatusToLabel).forEach(([apiStatus, label]) => {
    const regex = new RegExp(`\\b${apiStatus}\\b`, 'gi');
    translatedMsg = translatedMsg.replace(regex, label);
  });

  return translatedMsg;
}

export function getStatusLabel(apiStatus: string): string {
  return apiStatusToLabel[apiStatus] || apiStatus;
}

